export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const getInitials = (firstName, lastName) =>
  ((firstName?.[0] || '') + (lastName?.[0] || '')).toUpperCase() || '?';

export const getProgressColor = (status) => {
  const colorMap = {
    COMPLETED: '#10b981',
    IN_PROGRESS: '#7c3aed',
    NOT_STARTED: '#d1d5db',
  };
  return colorMap[status] || '#d1d5db';
};